import React, { useEffect, useState } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { fetchAllDataAPI } from '../../utils/api';
import { toast } from 'react-toastify';
import moment from 'moment';
import withAuth from '../../utils/withAuth';

const Annoucement = () => {
    const [notification, setNotification] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        getALLActiveNotification();
    }, []);

    const getALLActiveNotification = () => {
        setIsLoading(true);
        fetchAllDataAPI('hr-active-notification').then((res) => {
            if (res.data.status === 1) {
                setNotification(res.data.notification || []);
            } else {
                setNotification([]);
            }
            setIsLoading(false);
        }).catch(() => {
            setIsLoading(false);
        });
    };

    const renderSkeletonRows = () => {
        return Array(4).fill(0).map((_, index) => (
            <tr key={index}>
                <td><div className="skeleton skeleton-text w-75"></div></td>
                <td><div className="skeleton skeleton-text w-100"></div></td>
            </tr>
        ));
    };

    const renderNoDataFound = () => {
        return (
            <tr>
                <td colSpan="2" className="text-center text-secondary py-4">
                    🔔 No Notifications Found!
                </td>
            </tr>
        );
    };

    return (
        <div className="card radius-10 overflow-hidden w-100 annoucementsection topsection">
            <div className="titlesection d-flex border-bottom" style={{ justifyContent: "space-between" }}>
                <div className="mb-1 pl-2">
                    <h5>Notification / Announcement</h5>
                </div>
                <div className="mb-1">
                    <Link to="/notification"><AiOutlinePlus /> Add</Link>
                </div>
            </div>

            <div className="annoucementbody bodysection">
                <div className="annoucement table-responsive">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Notification</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading ? (
                                renderSkeletonRows()
                            ) : notification.length > 0 ? (
                                notification.map((item, index) => (
                                    <tr key={index}>
                                        <td>{moment(item?.create_date).format('Do MMM YYYY')}</td>
                                        <td>{item?.notification_name}</td>
                                    </tr>
                                ))
                            ) : (
                                renderNoDataFound()
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Skeleton CSS */}
            <style jsx="true">{`
                .skeleton {
                    background-color: #e2e2e2;
                    border-radius: 4px;
                    animation: shimmer 1.5s infinite linear;
                    height: 12px;
                    margin-bottom: 6px;
                }
                @keyframes shimmer {
                    0% { background-position: -400px 0; }
                    100% { background-position: 400px 0; }
                }
            `}</style>
        </div>
    );
};

export default withAuth(Annoucement);
